import React, { useState, useEffect, useContext } from 'react';
import * as net from "../../../lib/net";

import Ff_Input from "../../../lib/ui/ff_input";
import PdfRpDlg from "../fkn/pdf_rp_dlg";

class Kvitto_Wnd extends React.Component {
  constructor(props, context) {
    super(props);

    this.ctrl_plu = null;
    this.ctrl_text = null;
    this.ctrl_pris = null;

    //alert('PBO CTX: ' + JSON.stringify(props.pbo));
    this.store = props.store;
    this.state = {};
    this.state.cols = {};

    this.state.ix = 0;
    this.state.md_01 = false;
    this.state.plu = "";
    this.state.text = "";
    this.state.pris = "";
    this.state.kvo = props.kvo;
    this.state.raa = [];
    if(props.kvo.rader) this.state.raa = props.kvo.rader;
    this.state.paa = [];
    if(props.kvo.betrader) this.state.paa = props.kvo.betrader;

    this.state.pdf = 0;
    this.state.pdf_content = null;
    //alert('KVO: ' + JSON.stringify(props.kvo));
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.cdi_encode();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 350;
      css.overflow = "auto";
      return css;
  }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }
    prischange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pro = this.state.pro;
      var na = name.split(".");
      pro[na[1]] = value;
      this.setState({pro: pro});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    handleClose = () => {
		this.props.ctx.setState({ kvitto: false });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  md_toggle (event) {
    var self = this;
    self.setState({md_01: false });
    return;
  }
  plu_split (event) {
    var self = this;
    self.setState({md_01: true });
    return;
  }

  plu_sel (row) {
    var self = this;
    this.ctrl_plu.updateState(row.plu00.p0katnr);
    this.ctrl_text.updateState(row.plu00.p0namn.toswe());
    this.ctrl_pris.updateState(row.plu00.p0pris.cdipris());
    self.setState({plu: row.plu00.p0katnr, text: row.plu00.p0namn.toswe(), pris: row.plu00.p0pris.cdipris() });
    return;
  }

  plu_save (val) {
    var self = this;
    //alert("PLU: " + JSON.stringify(val));
    self.setState({plu: val });
    return;
  }

  text_save (val) {
    var self = this;
    //alert("TEXT: " + JSON.stringify(val));
    self.setState({text: val });
    return;
  }

  pris_save (val) {
    var self = this;
    //alert("PRIS: " + JSON.stringify(val));
    self.setState({pris: val });
    return;
  }

  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }
  prn_copy (event) {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_rp.inv_copy";
    prm.datum = this.state.kvo.datum;
    prm.avd = this.state.kvo.avd;
    prm.notanr = this.state.kvo.notanr;
    //alert(JSON.stringify(prm));

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok == "000") {
            //self.cdi_store();
        }
        self.setState({pdf: 1, pdf_content: ret.pdf });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
        self.setState({md_01: false });
    });
    return;
  }
  prn_combo (event) {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_rp.invrec_copy";
    prm.datum = this.state.kvo.datum;
    prm.avd = this.state.kvo.avd;
    prm.notanr = this.state.kvo.notanr;
    //alert(JSON.stringify(prm));

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok == "000") {
            //self.cdi_store();
        }
        self.setState({pdf: 1, pdf_content: ret.pdf });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
        self.setState({md_01: false });
    });
    return;
  }
  prn_multi (event) {
    var self = this;

    var prm = {};
    prm.req = "pos.pos_rp.inv_mcopy";
    prm.datum = this.state.kvo.datum;
    prm.avd = this.state.kvo.avd;
    prm.notanr = this.state.kvo.notanr;
    //alert(JSON.stringify(prm));

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok == "000") {
            //self.cdi_store();
        }
        self.setState({pdf: 1, pdf_content: ret.pdf });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
        self.setState({md_01: false });
    });
    return;
  }

  render() {
    //if(!this.props.show) return "";

    //alert(this.props.ctx.state.lro);

    var title = this.props.title;
    if(!title) title = "Plu";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>

        <div className="mx_content flex">
            <div className="flex-row" style={{padding:"5px",height:"30px"}}>
                    <div className="flex-row txt_18">
                        <div>KVITTO: </div>
                        <div>{ this.state.kvo.notanr.ztrim() }</div>
                    </div>
                    <div className="flex-row flex txt_18">
                    </div>
                    <div className="flex-row txt_18">
                        <div>BELOPP: </div>
                        <div>{ this.state.kvo.fsg.cdipris() }</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>Radnr</th>
                <th>Tid</th>
                <th>Text</th>
                <th>Antal</th>
                <th>Pris</th>
                <th>Summa</th>
                <th>ID</th>
                <th>Typ</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.raa.map((row, key) =>
                <tr key={key} id={ row.r0lopnr } className="" onDoubleClick={() => this.row_sel(row) }>
                <td className="">{ row.r0lopnr }</td>
                <td className="">{ row.r0tid }</td>
                <td className="">{ row.r0text.toswe() }</td>
                <td className="text-right">{ row.r0noof.ztrim() }</td>
                <td className="text-right">{ row.r0perprice.formatpris() }</td>
                <td className="text-right">{ row.r0perprice.formatpris() }</td>
                <td className="">{ row.r0sign }</td>
                <td className="">{ row.r0ttyp }</td>
                </tr>
            )}
            <tr><td colSpan="8"><div className="divider_green"></div></td></tr>
            { this.state.paa.map((row, key) =>
                <tr key={key} id={ row.r0lopnr } className="" onDoubleClick={() => this.row_sel(row) }>
                <td className="">{ row.r0lopnr }</td>
                <td className="">{ row.r0tid }</td>
                <td className="">{ row.r0text.toswe() }</td>
                <td className="text-right">{ row.r0noof.ztrim() }</td>
                <td className="text-right">{ row.r0perprice.formatpris() }</td>
                <td className="text-right">{ row.r0perprice.formatpris() }</td>
                <td className="">{ row.r0sign }</td>
                <td className="">{ row.r0ttyp }</td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.handleClose() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <div className="flex-row">
            <button className="btn btn-hw-green w250 ripple" onClick={(event) => this.prn_combo(event) } >
                SKRIV MED UNDERNOTOR
            </button>
            <button className="btn btn-hw-green w250 ripple" onClick={(event) => this.prn_copy(event) } >
                SKRIV UT
            </button>
            </div>
        </div>
      </div>

        <PdfRpDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
    </div>
	;
	return html;
  };
}

export default Kvitto_Wnd;